import { render, staticRenderFns } from "./collect-receipt-system.vue?vue&type=template&id=3c4c6d91&scoped=true&"
import script from "./collect-receipt-system.vue?vue&type=script&lang=js&"
export * from "./collect-receipt-system.vue?vue&type=script&lang=js&"
import style0 from "./collect-receipt-system.vue?vue&type=style&index=0&id=3c4c6d91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4c6d91",
  null
  
)

export default component.exports